import { matchPath } from 'react-router-dom'
import * as ROUTES from 'src/constants/routes'

const ROUTE_PATTERNS: string[] = (Object.values(ROUTES) as string[])
  .filter((route) => typeof route === 'string' && route.startsWith('/'))
  .sort((a, b) => {
    const bySegments = b.split('/').length - a.split('/').length

    if (bySegments !== 0) {
      return bySegments
    }

    return a.split(':').length - b.split(':').length
  })

export const matchRoutePattern = (pathname: string): string | undefined =>
  ROUTE_PATTERNS.find((pattern) => matchPath(pattern, pathname) !== null)
